module.exports = __webpack_public_path__ + "img/ch07_13_深夜实验室.bf0d0437.jpg";